/**
 * Lib.Common: CSS fallbacks for legacy/buggy browsers
 */


const haveIE =
    $build.platform != 'android' &&
    $build.platform != 'desktop' &&
    $build.platform != 'ios' &&
    /Trident\//.test(navigator.userAgent);

const el = document.createElement('div');
const havePaddingDir = 'marginBlockEnd' in el.style || 'webkitMarginEnd' in el.style;
const haveBorderDir = 'borderBlockEnd' in el.style;

let i = 0;
const style = document.createElement('style');
style.appendChild(document.createTextNode(''));
document.head.appendChild(style);

const insert = function(cls, props) {
    style.sheet.insertRule('[dir=ltr] .' + cls + ',[dir=rtl] [dir=ltr] .' + cls + '{' + props.replace(/S/g,'left').replace(/E/g,'right') + '}', i++);
    style.sheet.insertRule('[dir=rtl] .' + cls + ',[dir=ltr] [dir=rtl] .' + cls + '{' + props.replace(/E/g,'left').replace(/S/g,'right') + '}', i++);
};

if (!havePaddingDir) {
    const size = [[0,0], ['xxs','1px'], ['xs','2px'], ['sm','4px'], ['md','8px'], ['lg','16px'], ['xl','32px'], ['xxl','64px']];
    size.forEach(size => {
        insert('start-' + size[0], 'padding-S:' + size[1]);
        insert('end-' + size[0], 'padding-E:' + size[1]);
    });
}

if (!haveBorderDir) {
    insert('border-start', 'border-S-width:1px;border-S-style:solid');
    insert('border-end', 'border-E-width:1px;border-E-style:solid');
}

if (haveIE) {
    // Internet Explorer handles absolutely positioned flex children incorrectly
    style.sheet.insertRule('._fldl{top:calc(50% - .625em)}', i++);
}

function computeOnLoad() {
    el.style.position = 'fixed';
    el.style.borderTop = '.5px solid';
    el.style.textAlign = 'end';
    document.body.appendChild(el);
    const haveTextDir = getComputedStyle(el).getPropertyValue('text-align') == 'end';
    const haveSubpixelBorder = el.getBoundingClientRect().height < 1;
    document.body.removeChild(el);

    if (!haveTextDir) {
        insert('text-start', 'text-align:S');
        insert('text-end', 'text-align:E');
        insert('_tb th', 'text-align:S');
        insert('_field._astart ._fldin', 'text-align:S');
        insert('_field._aend ._fldin', 'text-align:E');
    }
    if (!haveSubpixelBorder && window.CSS && CSS.supports('color', 'var(--fake-var)')) {
        document.documentElement.classList.add('_spb');
    }
}

if (document.body) {
    computeOnLoad();
} else {
    addEventListener('load', computeOnLoad);
}
